;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import * as Sentry from "@sentry/nextjs"
import { errorMessageVar } from "../../reactiveVars"

type ErrorMessageInput =
  | string
  | {
      message: string
      duration?: number
      trackToSentry?: boolean
      error?: unknown
    }
  | null

export default function updateErrorMessage(errorMessage: ErrorMessageInput): void {
  if (typeof errorMessage === "string") {
    errorMessageVar({
      message: errorMessage,
      duration: 3000,
    })
    return
  }

  if (errorMessage === null) {
    errorMessageVar(null as any)
    return
  }

  if (typeof errorMessage === "object" && errorMessage.message) {
    const normalizedErrorMessage = {
      ...errorMessage,
      duration: errorMessage.duration ?? 3000,
    }

    if (normalizedErrorMessage.trackToSentry) {
      if (normalizedErrorMessage.error) {
        Sentry.captureException(normalizedErrorMessage.error)
      } else {
        Sentry.captureException(new Error(normalizedErrorMessage.message))
      }
    }

    errorMessageVar(normalizedErrorMessage as any)
    return
  }

  throw new Error("Invalid errorMessage format")
}
